<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

// 打开手机端控制台
// import VConsole from "vconsole";
// new VConsole();

export default {
  data() {
    return {

    }
  },
  created() {
  
  },
  mounted() {
  },
  methods: {
    
  
  }
}
</script>
 
<style scoped>
#app {
  background-size: 100% 100%;
  width: 10rem;
  margin: auto;
}
</style>
